import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as act from "../../../store/actions/anonHomeForm";
import {
  setPolicyNumber,
  sendPropertyForm,
} from "../../../store/actions/anonymousForms";
import { formatSummaryDateTime } from "../../../utilities/formatUtilities";
import PageWrapper from "../../shared/wizard/PageWrapper";
import SummarySection from "../components/SummarySection";
import SummaryText from "../components/SummaryText";
import SummaryEditModal from "../components/SummaryEditModal";
import DateTimeEdit from "../edit-screens/shared-edit-screens/DateTimeEdit";
import YourInfoEdit from "../edit-screens/shared-edit-screens/YourInfoEdit";
import PolicyNumberEdit from "../edit-screens/shared-edit-screens/PolicyNumberEdit";
import LocationEdit from "../edit-screens/shared-edit-screens/LocationEdit";
import IncidentDetailsEdit from "../edit-screens/shared-edit-screens/IncidentDetailsEdit";
import WitnessesEdit from "../edit-screens/shared-edit-screens/WitnessesEdit";
import DocumentsEdit from "../edit-screens/shared-edit-screens/DocumentsEdit";
import InjuryEdit from "../edit-screens/home-edit-screens/InjuryEdit";
import OtherPropertyEdit from "../edit-screens/home-edit-screens/OtherPropertyEdit";
import SubmitConfirmAlert from "../components/SubmitConfirmAlert";
import Styles from "../styles/AnonSummaryStyles.module.css";
import { BehalfOfOptions, damageTypes, userTypes } from "../../../constants/options";
import { Canada } from "../../../constants/data";
import {
  concatenateName,
  copyNestedObj,
  countryToCode,
  nameIsBlank,
  stateCodeToName,
  stateNameToCode,
  textToBoolean,
} from "../../../utilities/dataUtilities";
import { damageKeys, formTypes } from "../../../constants/keys";
import { fieldsToStrings, mapPersonArray } from "../../../utilities/forms/formSubmissionUtilities";

function HomeClaimSummary({
  handleDocuments,
  config,
  fields,
  utilities,
  validatePage,
  witnesses,
  setWitnesses,
  setFields
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  let documents = useSelector((state) => state.anonHomeForm.documents);
  let policyNumber = useSelector((state) => state.anonymousForms.policyNumber);
  let policyTypeToggle = useSelector(
    (state) => state.anonymousForms.policyTypeToggle
  );
  let lossCauses = useSelector((state) => state.forms.lossCauses);
  let typeOfClaim = useSelector((state) => state.anonymousForms.typeOfClaim);

  const witnessDisplay = [];
  witnesses
    .filter((witness) => !nameIsBlank(witness))
    .forEach((witness, index) => {
      witnessDisplay.push([
        `Name ${index + 1} `,
        `${concatenateName(witness)}`,
      ]);
      witnessDisplay.push([`Phone ${index + 1} `, witness.witnessPhone.value]);
    });

  //placeholder for unentered data
  const blankMessage = "- - -";

  const [displayAlert, setDisplayAlert] = useState(false);

  const [displayEdit, setDisplayEdit] = useState(false);

  const [originalValues, setOriginalValues] = useState(copyNestedObj(fields));

  useEffect(() => {
    if (displayEdit === false) {
      setOriginalValues(copyNestedObj(fields));
    }
  }, [displayEdit])

    const updateClicked = () => {
    if (validatePage(editPage, true)) {
      setDisplayEdit(false);
    }
  };

  const cancelClicked = () => {
    setFields(originalValues);
    setDisplayEdit(false);
  };

  const editScreens = [
    <DateTimeEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <PolicyNumberEdit
      policyNum={policyNumber}
      setPolicyNum={setPolicyNumber}
      setIsVisible={setDisplayEdit}
    />,
    <YourInfoEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <LocationEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <IncidentDetailsEdit
      lossCauses={lossCauses}
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <WitnessesEdit
      setIsVisible={setDisplayEdit}
      isVisible={displayEdit}
      witnesses={witnesses}
      setWitnesses={setWitnesses}
      fields={fields}
      utilities={utilities}
      validatePage={validatePage}
      cancel={cancelClicked}
    />,
    <InjuryEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <OtherPropertyEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <DocumentsEdit
      documents={documents}
      setDocuments={act.setHomeDocuments}
      config={config}
      handleDocuments={handleDocuments}
      setIsVisible={setDisplayEdit}
    />,
  ];
  const [editPage, setEditPage] = useState(0);
  const handleEditPage = (page) => {
    setEditPage(page);
    setDisplayEdit(true);
  };

  // returns a JSX snippet for displaying the values
  // in the form, e.g. Name: name entered
  const displayValue = (label, value, required, editNumber) => {
    return (
      <p className={Styles.formValue}>
        {label && <b>{label}: &nbsp;&nbsp;</b>}
        {value ? (
          <span>{value}</span>
        ) : required ? (
          <span
            className={Styles.required}
            onClick={() => handleEditPage(editNumber)}
          >
            Field required
          </span>
        ) : (
          blankMessage
        )}
      </p>
    );
  };

  function handleSubmit() {

    let formData = {...fields};
    formData = fieldsToStrings(formData);
    formData.userType = userTypes.findIndex(type => type.value === formData.userType);
    formData.onBehalfOf = formData.userType === 1 && formData.onBehalfOf === BehalfOfOptions[1]
      ? true
      : false;
    formData.lossCauseFull = formData.lossCause;
    formData.lossCause = lossCauses.find((item) => item.FullText === formData.lossCause)
          ?.Code;
    formData.whereCountry = countryToCode(formData.whereCountry);
    if (formData.whereCountry === Canada.code) {
      formData.whereState = stateNameToCode(formData.whereState);
    }
    formData.whereProvenanceCanada = formData.whereState;
    formData.whereStateMexico = formData.whereState;
    formData.whereZipcodeCanada = formData.whereZipcode;
    formData.propertyOwnerProvenanceCanada = formData.propertyOwnerState;
    formData.propertyOwnerStateMexico = formData.propertyOwnerState;
      formData.propertyOwnerZipcodeCanada = formData.propertyOwnerZipcode;
      formData.damageToProperty = textToBoolean(formData.damageToProperty);
      formData.witnesses = mapPersonArray(witnesses);
      formData.witnessesPresent = textToBoolean(formData.witnessesPresent);
      formData.wasAnyoneInjured = textToBoolean(formData.wasAnyoneInjured);
      formData.injuredparty = [];
      if (formData.wasAnyoneInjured) {
        const injured = {
          firstName: formData.injuredFirstName,
          lastName: formData.injuredLastName,
          injuredPartyAddress: formData.injuredAddress,
          injuredPartyCity: formData.injuredCity,
          injuredPartyState: formData.injuredState,
          injuredPartyCounty: formData.injuredCounty,
          injuredPartyZipcode: formData.injuredZipcode,
          injuredPartyDescriptionOfInjury: formData.injuryDescription,
          wasMedicalTreatmentProvided: formData.wasTreatmentProvided,
          medicalProviderFirstName: formData.medicalProviderFirstName,
          medicalProviderLastName: formData.medicalProviderLastName,
          wasMedicalTreatmentProvidedAddress: formData.medicalProviderAddress,
          wasMedicalTreatmentProvidedCity: formData.medicalProviderCity,
          wasMedicalTreatmentProvidedState: formData.medicalProviderState,
          wasMedicalTreatmentProvidedZipcode: formData.medicalProviderZipcode
        };
        formData.injuredparty.push(injured);
      }
      delete formData.injuredFirstName;
      delete formData.injuredLastName;
      delete formData.injuredAddress;
      delete formData.injuredCity;
      delete formData.injuredState;
      delete formData.injuredCounty;
      delete formData.injuredZipcode;
      delete formData.injuryDescription;
      delete formData.wasTreatmentProvided;
      delete formData.medicalProviderFirstName;
      delete formData.medicalProviderLastName;
      delete formData.medicalProviderAddress;
      delete formData.medicalProviderCity;
      delete formData.medicalProviderState;
      delete formData.medicalProviderZipcode;
      formData.policyNumber = policyNumber || "000000000";
      delete formData.confirmEmail;
      formData.policySuccess = false;
      formData.claimType = policyTypeToggle[1].selected
      ? "Property/Liability"
      : "Property";
      if (typeOfClaim === formTypes.Home) {
        formData.formType = damageTypes.find(item => item.label === formData.damageType)?.value === damageKeys.Liability
          ? damageKeys.Liability : formTypes.Home;
      } else {
        formData.formType = typeOfClaim;
      }
      dispatch(
        sendPropertyForm(
          formData,
          documents.files,
          history
        )
      );
  }

  return (
    <>
      <SubmitConfirmAlert
        isVisible={displayAlert}
        setIsVisible={setDisplayAlert}
        handleSubmit={handleSubmit}
      />
      <SummaryEditModal isVisible={displayEdit} setIsVisible={setDisplayEdit}>
        {editScreens[editPage]}
      </SummaryEditModal>

      <PageWrapper legendInfo="Claim Summary">
        <div className={Styles.review}>
          <p>
            Please review the details below and make any necessary changes
            before submitting your claim.
          </p>

          <hr className={Styles.hr} />
          {displayValue("Type of Claim", typeOfClaim)}
          <hr className={Styles.hr} />

          {displayValue(
            "Date and Time Of Incident",
            formatSummaryDateTime(fields.whereDate.value, fields.whereTime.value) &&
              fields.whereDate.value.substring(0, 4) > 1949 &&
              fields.whereDate.value.substring(0, 4) <= new Date().getFullYear() ? (
              formatSummaryDateTime(fields.whereDate.value, fields.whereTime.value)
            ) : (
              <span
                className={Styles.required}
                onClick={() => handleEditPage(0)}
              >
                A valid date and time are required.
              </span>
            )
          )}
          <button
            type="button"
            className={Styles.editButton}
            onClick={() => handleEditPage(0)}
          >
            Edit
          </button>
          <hr className={Styles.hr} />

          {displayValue("Policy Number", policyNumber)}
          <button
            type="button"
            className={Styles.editButton}
            onClick={() => handleEditPage(1)}
          >
            Edit
          </button>
          <hr className={Styles.hr} />
        </div>
        <div className={Styles.flexRow}>
          <div className={Styles.summaryContainer}>
            <div className={Styles.summaryRow}>
              <SummarySection title="Claimant Information" alignment="whole">
                {displayValue("First Name", fields.contactFirstName.value)}
                {displayValue("Last Name", fields.contactLastName.value)}
                <span className={Styles.breakWord}>
                  {displayValue("Email", fields.contactEmail.value, true, 2)}
                </span>
                {displayValue("Phone", fields.contactPhone.value, true, 2)}
                <span className={Styles.breakWord}>
                  {displayValue("Confirm", fields.confirmEmail.value, true, 2)}
                </span>
                {displayValue("You are", fields.userType.value)}
                <span></span>
                {fields.userType.value === userTypes[1].value &&
                  displayValue("Filing On Behalf Of", fields.onBehalfOf.value, true, 2)}
              </SummarySection>
            </div>
            {fields.userType.value === userTypes[1].value &&
              fields.onBehalfOf.value === BehalfOfOptions[1] && (
                <>
                  <p className={Styles.hr}></p>
                  <SummaryText title="Third Party Claimant">
                    {displayValue("First Name", fields.behalfOfFirst.value, false, 2)}
                    {displayValue("Last Name", fields.behalfOfLast.value, true, 2)}
                  </SummaryText>
                </>
              )}
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(2)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr} />
            <div className={Styles.summaryRow}>
              <SummarySection title="Incident Location" alignment="left">
                {displayValue("Address", fields.whereAddress.value)}
                {displayValue("City", fields.whereCity.value)}
                {fields.whereCountry.value === Canada.name
                  ? displayValue(
                      "Province",
                      stateCodeToName(fields.whereState.value),
                      true,
                      3
                    )
                  : displayValue("State", fields.whereState.value, true, 3)}
                {displayValue("Zip Code", fields.whereZipcode.value)}
                {displayValue("County", fields.whereCounty.value)}
                {displayValue("Country", fields.whereCountry.value)}
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(3)}
                >
                  Edit
                </button>
              </SummarySection>
              <SummarySection title="Incident Details" alignment="right">
                {displayValue("Incident Description", fields.whatHappen.value, true, 4)}
                {typeOfClaim === formTypes.Home &&
                  displayValue(
                    "Damage Party",
                    fields.damageType.value,
                    true,
                    4
                  )}
                {displayValue("Cause of Loss", fields.lossCause.value, true, 4)}
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(4)}
                >
                  Edit
                </button>
              </SummarySection>
            </div>
            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              {!fields.witnessesPresent.value ||
              witnesses.every((witness) => nameIsBlank(witness)) ? (
                <SummaryText title="Witnesses">
                  <p>No witnesses reported.</p>
                </SummaryText>
              ) : (
                <SummarySection title="Witnesses" alignment="whole">
                  {witnessDisplay.map((entry) =>
                    displayValue(entry[0], entry[1])
                  )}
                </SummarySection>
              )}
            </div>
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(5)}
              >
                Edit
              </button>
            </div>

            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              {!textToBoolean(fields.wasAnyoneInjured.value) ? (
                <SummaryText title="Injury Information">
                  <p>No injury reported.</p>
                </SummaryText>
              ) : (
                <>
                  <SummarySection title="Injury Information" alignment="whole">
                    {displayValue("First Name", fields.injuredFirstName.value)}
                    {displayValue("Last Name", fields.injuredLastName.value)}
                    {displayValue("Address", fields.injuredAddress.value)}
                    {displayValue("City", fields.injuredCity.value)}
                    {displayValue("State", fields.injuredState.value)}
                    {displayValue("Zip Code", fields.injuredZipcode.value)}
                    {displayValue("County", fields.injuredCounty.value)}
                    {displayValue("Injury Description", fields.injuryDescription.value)}
                    <p></p>
                  </SummarySection>
                </>
              )}
            </div>
            {fields.wasTreatmentProvided.value && textToBoolean(fields.wasAnyoneInjured.value) && (
              <div className={Styles.summaryRow}>
                <SummarySection
                  title={`Provider Information ${
                    nameIsBlank({firstName: fields.medicalProviderFirstName, lastName: fields.medicalProviderLastName})
                      ? ""
                      : concatenateName({firstName: fields.medicalProviderFirstName, lastName: fields.medicalProviderLastName})
                  }`}
                  alignment="whole"
                >
                  {displayValue("Address", fields.medicalProviderAddress.value)}
                  {displayValue("City", fields.medicalProviderCity.value)}
                  {displayValue("State", fields.medicalProviderState.value)}
                  {displayValue("Zip Code", fields.medicalProviderZipcode.value)}
                </SummarySection>
              </div>
            )}
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(6)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr} />

            {textToBoolean(fields.damageToProperty.value) && fields.whoOwnsProperty.value ? (
              <>
                <div className={Styles.summaryRow}>
                  <SummarySection
                    title="Additional Damaged Property"
                    alignment="whole"
                  >
                    {displayValue("Owner's First Name", fields.propertyOwnerFirstName.value)}
                    {displayValue(
                      "Owner's Last Name",
                      fields.propertyOwnerLastName.value,
                      true,
                      7
                    )}
                    {displayValue("Address", fields.propertyOwnerAddress.value)}
                    {displayValue("City", fields.propertyOwnerCity.value)}
                    {displayValue("State", fields.propertyOwnerState.value)}
                    {displayValue("County", fields.propertyOwnerCounty.value)}
                    {displayValue("Zip Code", fields.propertyOwnerZipcode.value)}
                    {displayValue("Estimate", `$ ${fields.propertyOwnerEstimateOfDamage.value}`)}
                    <p></p>
                  </SummarySection>
                </div>
                <div className={Styles.summaryRow}>
                  <SummaryText title="Description of the Property">
                    {displayValue("", fields.propertyOwnerDescribeProperty.value, true, 7)}
                  </SummaryText>
                </div>
                <div className={Styles.summaryRow}>
                  <SummaryText title="Description Of the Damage to the Property">
                    {displayValue("", fields.propertyOwnerDamageProperty.value, true, 7)}
                  </SummaryText>
                </div>
                <div className={Styles.summaryRow}>
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(7)}
                  >
                    Edit
                  </button>
                </div>
              </>
            ) : (
              <div className={Styles.summaryRow}>
                <SummaryText title="Additional Damaged Property">
                  <p>No information provided.</p>
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(7)}
                  >
                    Edit
                  </button>
                </SummaryText>
              </div>
            )}

            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              {documents.size > 0 ? (
                <SummaryText title="Uploaded Files" alignment="whole">
                  {documents.files.map((file, index) =>
                    displayValue(`File ${index + 1} `, file.name)
                  )}
                  {documents.size % 2 === 1 && <p></p>}
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(8)}
                  >
                    Edit
                  </button>
                </SummaryText>
              ) : (
                <SummaryText title="Uploaded Files">
                  <p>No documents uploaded.</p>
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(8)}
                  >
                    Edit
                  </button>
                </SummaryText>
              )}
            </div>

            <hr className={Styles.hr} />
            <div className={Styles.summaryRow}>
              <button
                className={Styles.reportButton}
                type="button"
                onClick={(e) => handleSubmit(e)}
              >
                Report Your Claim
              </button>
            </div>
          </div>
        </div>
      </PageWrapper>
    </>
  );
}

export default HomeClaimSummary;
